interface Config {
  [key: string]: unknown;
}
interface GenericConfig {
  config: Config;
  startTime: number;
  occupationSearch: string;
  abnLookUpStatus: boolean;
}

/* eslint-disable */
class AnalyticsConfig implements GenericConfig {
  private _startTime: number;

  private _config: Config;

  private _occupationSearch: string;

  private _abnLookupStatus: boolean;

  constructor() {
    this._startTime = 0;
    this._config = {};
    this._occupationSearch = ''; // Expect value, quickSearch, quickSearchSuccess, iconSearch
    this._abnLookupStatus = false;
  }

  set startTime(value: number) {
    this._startTime = value;
  }

  get startTime() {
    return this._startTime;
  }

  set occupationSearch(value: string) {
    this._occupationSearch = value;
  }

  get occupationSearch() {
    return this._occupationSearch;
  }

  set abnLookUpStatus(value: boolean) {
    this._abnLookupStatus = value;
  }

  get abnLookupStatus() {
    return this._abnLookupStatus;
  }

  set config(newConfig: Config) {
    this._config = {
      ...this._config,
      ...newConfig,
    };
  }

  get config() {
    return this._config;
  }
}

export const analyticsConfig = new AnalyticsConfig();
